// extracted by mini-css-extract-plugin
export default {"lang":"LanguageSwitcher_lang__ZqQat","separator":"LanguageSwitcher_separator__npI1b"};